import axios from 'axios';
import parseLinkHeader from 'parse-link-header';

import { addAlert } from 'components/shared/Alert';
import { refreshToken, storeFailedApiCall } from 'redux/auth/actions';
import history from 'utils/history';
import { logout } from 'utils/jwt';

const setAuthorizationHeader = (config, jwt) => {
    let token = jwt;

    // If the user has an old token that was stored with the "Bearer " prefix, remove it
    if (token.includes('Bearer ')) {
        token = token.replace('Bearer ', '');
    }

    return {
        ...config,
        headers: { ...config.headers, Authorization: `Bearer ${token}` }
    };
};

export const http = axios.create({ baseURL: process.env.REACT_APP_API_URL });

export const httpConfig = {
    interceptors: {
        request: [{
            error: (options, error) => Promise.reject(error),
            success: ({ getState }, config) => {
                const jwt = getState().auth.get('jwt');

                if (jwt) {
                    return setAuthorizationHeader(config, jwt);
                }

                return config;
            }
        }],
        response: [{
            error: ({ dispatch, getSourceAction }, error) => {
                const { config, response } = error;
                const { data, status } = response;
                const getMessage = (obj) => {
                    const message = obj[Object.keys(obj)[0]];
                    return Array.isArray(message) ? message[0] : message;
                };

                // If the token can't be refreshed, log the user out
                if (error.response.request.responseURL.includes('/api/v1/auth/refresh')) {
                    return logout(true);
                }

                switch (status) {
                    case 400: // bad request
                        addAlert({ message: getMessage(data) });
                        break;

                    case 401: // unauthorized
                        dispatch(storeFailedApiCall(getSourceAction(config)));
                        dispatch(refreshToken());

                        break;

                    case 402: // no subscription
                        // dispatch(showNoSubscription());
                        break;

                    case 403: // forbidden
                        addAlert({ message: getMessage(data) });
                        break;

                    case 422: // error from backend
                        addAlert({ message: getMessage(data) });
                        break;

                    case 503: // maintenance
                        history.push('/maintenance');
                        break;

                    default:
                        // eslint-disable-next-line
                        console.error(error);
                        addAlert({ message: 'There was an error with your request.' });
                        break;
                }

                return Promise.reject(error);
            },
            success: (options, response) => {
                // Merge headers so that there is always a default value
                const headers = {
                    link: '<>; rel="previous", <>; rel="next"',
                    'x-pages-current-page': '1',
                    'x-pages-last-page': '1',
                    'x-pages-total-count': '1',
                    ...response.headers,
                };
                const link = parseLinkHeader(headers.link);
                const res = { ...response };
                res.headers = headers;
                res.pagination = {
                    currentPage: Number(res.headers['x-pages-current-page']),
                    lastPage: Number(res.headers['x-pages-last-page']),
                    nextPage: link.next.url,
                    previousPage: link.previous.url,
                    totalCount: Number(res.headers['x-pages-total-count'])
                };

                return res;
            }
        }],
    },
    returnRejectedPromiseOnError: true,
};

export default http;



// WEBPACK FOOTER //
// ./src/utils/http.js